import { useState, useContext } from "react";
import { Form, Input, Button, DatePicker, Card } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { AuthContext } from "../../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EyeOutlined } from "@ant-design/icons";
import ApproveTI from "../../pages/hr/ApproveTI"


export default function TechnicalIssue() {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const { authData, backUrl } = useContext(AuthContext);

    const [showIssues, setShowIssues] = useState(false)

    const onFinish = async (values) => {
        const payload = {
            title: values.title,
            reason: values.reason,
            date: values.date.format("YYYY-MM-DD"),
        };

        try {
            setLoading(true);

            await axios.post(
                `${backUrl}/api/hr/technical-issues/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            toast.success("Technical issue submitted successfully");
            form.resetFields();
        } catch (error) {
            toast.error(
                error.response?.data?.message || "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <a onClick={() => setShowIssues(!showIssues)}><EyeOutlined style={{ marginRight: 6 }} /> {showIssues ? "Close Issues" : "Show Issues"}</a>
            <br />
            <br />
            {
                showIssues && (
                    <>
                        <ApproveTI />
                    </>
                )
            }

            {
                !showIssues && (
                    <center>

                        <Card title="Raise Technical Issue" style={{ maxWidth: 500 }}>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                                initialValues={{
                                    date: dayjs(),
                                }}
                            >
                                <Form.Item
                                    label="Title"
                                    name="title"
                                    rules={[{ required: true, message: "Please enter title" }]}
                                >
                                    <Input placeholder="Enter issue title" />
                                </Form.Item>

                                <Form.Item
                                    label="Reason"
                                    name="reason"
                                    rules={[{ required: true, message: "Please enter reason" }]}
                                >
                                    <Input.TextArea
                                        rows={4}
                                        placeholder="Describe the technical issue"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Date"
                                    name="date"
                                    rules={[{ required: true, message: "Please select date" }]}
                                >
                                    <DatePicker style={{ width: "100%" }} />
                                </Form.Item>

                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={loading}
                                        style={{ background: "#0e497b", color: "white" }}
                                    >
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>

                        {/* Toast container */}
                        <ToastContainer
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            pauseOnHover
                        />
                    </center>
                )
            }

        </>
    );
}
